export function truncateShareText(text, maxLength = 220) {
    if (!text) return '';
    const normalized = String(text).replace(/\s+/g, ' ').trim();
    if (normalized.length <= maxLength) return normalized;
    return `${normalized.slice(0, maxLength - 3).trim()}...`;
}

export function getSharePageUrl(shareHash = '') {
    if (typeof window === 'undefined') return '';

    const hash = shareHash
        ? (shareHash.startsWith('#') ? shareHash : `#${shareHash}`)
        : '';

    return `${window.location.origin}${window.location.pathname}${hash}`;
}

export function buildSharePayload({ title, text, shareHash }) {
    const url = getSharePageUrl(shareHash);
    const body = truncateShareText(text || title || '');
    const message = title && body && body !== title
        ? `${title} — ${body}`
        : (title || body);

    return { url, message, title: title || 'NeuraTrader' };
}

export function getShareLinks({ title, text, shareHash }) {
    const { url, message, title: shareTitle } = buildSharePayload({ title, text, shareHash });
    const encodedUrl = encodeURIComponent(url);
    const encodedMessage = encodeURIComponent(message);
    const encodedTitle = encodeURIComponent(shareTitle);

    return [
        {
            id: 'x',
            label: 'Share on X',
            icon: 'simple-icons:x',
            href: `https://twitter.com/intent/tweet?text=${encodedMessage}&url=${encodedUrl}`,
        },
        {
            id: 'facebook',
            label: 'Share on Facebook',
            icon: 'mdi:facebook',
            href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        },
        {
            id: 'linkedin',
            label: 'Share on LinkedIn',
            icon: 'mdi:linkedin',
            href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
        },
        {
            id: 'whatsapp',
            label: 'Share on WhatsApp',
            icon: 'mdi:whatsapp',
            href: `https://wa.me/?text=${encodeURIComponent(`${message} ${url}`)}`,
        },
        {
            id: 'telegram',
            label: 'Share on Telegram',
            icon: 'mdi:telegram',
            href: `https://t.me/share/url?url=${encodedUrl}&text=${encodedMessage}`,
        },
        {
            id: 'reddit',
            label: 'Share on Reddit',
            icon: 'mdi:reddit',
            href: `https://www.reddit.com/submit?url=${encodedUrl}&title=${encodedTitle}`,
        },
        {
            id: 'instagram',
            label: 'Share on Instagram',
            icon: 'simple-icons:instagram',
            action: 'instagram',
        },
        {
            id: 'tiktok',
            label: 'Share on TikTok',
            icon: 'simple-icons:tiktok',
            href: `https://www.tiktok.com/share?url=${encodedUrl}`,
        },
    ];
}

export function getInstagramShareCaption({ title, text, shareHash }) {
    const { url, message } = buildSharePayload({ title, text, shareHash });
    return `${message}\n\n${url}`;
}